"use strict";

exports.__esModule = true;
exports.SPACINGS_AFTER = exports.PLACEMENTS = void 0;
let PLACEMENTS = exports.PLACEMENTS = /*#__PURE__*/function (PLACEMENTS) {
  PLACEMENTS["AUTO"] = "auto";
  PLACEMENTS["AUTO_START"] = "auto-start";
  PLACEMENTS["AUTO_END"] = "auto-end";
  PLACEMENTS["TOP"] = "top";
  PLACEMENTS["TOP_START"] = "top-start";
  PLACEMENTS["TOP_END"] = "top-end";
  PLACEMENTS["BOTTOM"] = "bottom";
  PLACEMENTS["BOTTOM_START"] = "bottom-start";
  PLACEMENTS["BOTTOM_END"] = "bottom-end";
  PLACEMENTS["RIGHT"] = "right";
  PLACEMENTS["RIGHT_START"] = "right-start";
  PLACEMENTS["RIGHT_END"] = "right-end";
  PLACEMENTS["LEFT"] = "left";
  PLACEMENTS["LEFT_START"] = "left-start";
  PLACEMENTS["LEFT_END"] = "left-end";
  return PLACEMENTS;
}({});
let SPACINGS_AFTER = exports.SPACINGS_AFTER = /*#__PURE__*/function (SPACINGS_AFTER) {
  SPACINGS_AFTER["NONE"] = "none";
  SPACINGS_AFTER["SMALLEST"] = "smallest";
  SPACINGS_AFTER["SMALL"] = "small";
  SPACINGS_AFTER["NORMAL"] = "normal";
  SPACINGS_AFTER["MEDIUM"] = "medium";
  SPACINGS_AFTER["LARGE"] = "large";
  SPACINGS_AFTER["LARGEST"] = "largest";
  return SPACINGS_AFTER;
}({});